module.exports = __webpack_public_path__ + "img/z01.54401404.jpg";